import { useContext } from 'react';
import { EmbedModeContext } from './EmbedModeProvider.tsx';

export const useIsEmbedMode = (): boolean => useContext(EmbedModeContext);
